module.exports = "<app-appointment [isAdmin]=\"false\"></app-appointment>"